var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 2111 l-33 -29 0 -950 c0 -1022 -2 -987 52 -1011 17 -8 246 -11 774 -11 l751 0 32 33 33 32 1 290 2 290 -45 -50 -45 -50 0 -226 0 -226 -31 -7 c-17 -3 -348 -6 -735 -6 l-704 0 0 935 0 935 719 0 c396 0 726 -3 735 -6 14 -5 16 -48 16 -373 l0 -366 47 48 46 49 -5 336 -6 336 -31 28 -31 28 -755 0 -755 0 -32 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 1835 l0 -45 575 0 575 0 0 45 0 45 -575 0 -575 0 0 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 1570 l0 -40 575 0 575 0 0 40 0 40 -575 0 -575 0 0 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509 1093 c-223 -235 -408 -434 -413 -441 -11 -18 -87 -334 -82 -339 2 -2 77 17 166 44 l162 47 326 346 c180 190 364 384 409 432 70 73 83 92 83 120 0 117 -73 194 -201 212 l-46 7 -404 -428z m496 323 c36 -15 60 -45 70 -88 11 -44 -14 -35 -78 30 -31 32 -57 61 -57 65 0 11 28 8 65 -7z m-57 -127 l63 -60 -258 -272 c-142 -149 -296 -312 -343 -361 l-86 -88 -59 52 c-33 28 -63 57 -66 63 -4 7 103 128 260 294 146 155 298 316 336 357 39 41 75 75 80 75 6 0 38 -27 73 -60z m-734 -797 l28 -31 -53 -15 c-29 -9 -55 -16 -57 -16 -5 0 8 92 15 103 6 10 33 -6 67 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 1300 l0 -40 575 0 575 0 0 40 0 40 -575 0 -575 0 0 -40z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.b454d54c1548aa1c575d2db42dd9ad39.svg";
export { ForwardRef as ReactComponent };